import { useEffect } from "react";
import zoomSdk from "@zoom/appssdk";
import LogManager from "../../utils/logManager";
import { openUrl } from "../../utils/zoomSdkUtils";
import Button from "@amzn/awsui-components-console/button";
import "./Login.css";
import aimsLogo from "../../images/aims_logo.svg";
import { CLIENT_ID_BY_ENV, IDP_BY_ENV, OAUTH_COOKIE_MAX_AGE_S, OAUTH_TOKEN_LENGTH } from "./login.constants";
import { generateRandomString } from "./login.utils";
import { ZOOM_RUNNING_CONTEXT } from "../../constants";

const Login = () => {
  console.log("In login page");
  /**
   * Initialize Zoom SDK
   */
  const initializeZoomSdk = async () => {
    if (window.location.href === "http://localhost:3000/") {
      console.log("[Localhost] Skipping zoomSdk.config() in localhost");
      return;
    }
    try {
      const configResponse = await zoomSdk.config({
        popoutSize: { width: 320, height: 760 },
        capabilities: ["getRunningContext", "getUserContext", "getMeetingContext", "getMeetingUUID", "openUrl"],
      });
      console.log("Zoom SDK Configured Successfully:", configResponse);
      LogManager.info("Zoom SDK Configured Successfully:", configResponse);

      const runningContext = await zoomSdk.getRunningContext();
      console.log("The runningContext is:", runningContext);
      LogManager.info("[Login] The runningContext is:", runningContext);

      // Emit the page-view metric only after the SDK is configured, so the context/role
      // dimensions are available. Emitting it in useEffect (before config resolves) races
      // the SDK and lands with empty dimensions.
      const dimensions = {};
      if (runningContext.context) {
        dimensions.context = runningContext.context;
      }
      if (runningContext.context === ZOOM_RUNNING_CONTEXT.IN_MEETING) {
        const userContext = await zoomSdk.getUserContext();
        console.log("[Login] userContext:", userContext);
        LogManager.info("[Login] User on login page, screenName: " + userContext.screenName + ", role: " + userContext.role);
        if (userContext.role) {
          dimensions.userRole = userContext.role;
        }
      }
      LogManager.metric("Login_PageView", 1, dimensions);
    } catch (error) {
      console.error("Error fetching context or call APIs:", error);
      LogManager.error("Error fetching context or call APIs:", error);
      // Still record the page view even if context lookup failed; backend fills unknown dimensions.
      LogManager.metric("Login_PageView", 1);
    }
  };

  useEffect(() => {
    initializeZoomSdk();
  }, []);

  const handleLogin = async () => {
    LogManager.metric("Login_ButtonClick", 1);
    let fullHost = window.location.hostname;
    console.log("[Login] FullHost is:", fullHost);

    const runningContext = await zoomSdk.getRunningContext();
    console.log("[Login] RunningContext is:", runningContext);
    LogManager.info("[Login] User clicked login button, runningContext: " + runningContext.context);

    let statePrefix = "";
    if (runningContext.context === ZOOM_RUNNING_CONTEXT.IN_MEETING) {
      statePrefix = "meeting";
    } else if (runningContext.context === ZOOM_RUNNING_CONTEXT.IN_MAIN_CLIENT) {
      statePrefix = "mainclient";
    }

    const state = statePrefix + generateRandomString(OAUTH_TOKEN_LENGTH);
    const nonce = generateRandomString(OAUTH_TOKEN_LENGTH);

    document.cookie = `aims_state=${state}; path=/; Secure; SameSite=Strict; Max-Age=${OAUTH_COOKIE_MAX_AGE_S}; Domain=${fullHost}`;
    //Nonce is the RFP token here
    document.cookie = `aims_rfp=${nonce}; path=/; Secure; SameSite=Strict; Max-Age=${OAUTH_COOKIE_MAX_AGE_S}; Domain=${fullHost}`;
    console.log(document.cookie);

    const envKey = fullHost.split(".")[1];
    console.log(envKey);
    let clientID;
    if (envKey === "test") {
      // for dev stack, full host is {alias}devaimsui.test.aims.meetex.enterprise-engineering.aws.dev
      const devEnvKey = fullHost.split(".")[0];
      console.log("devEnvKey is: " + devEnvKey);
      clientID = CLIENT_ID_BY_ENV.get(devEnvKey);
    } else {
      clientID = CLIENT_ID_BY_ENV.get(envKey);
    }
    console.log("ClientID is:" + clientID);
    const idp = IDP_BY_ENV.get(envKey);
    console.log(idp);

    const redirectUrl = `${idp}/api/oauth2/v1/authorize?client_id=${clientID}&redirect_uri=https://${fullHost}/login-redirect&response_type=code&scope=openid&state=${state}&nonce=${nonce}`;

    console.log("Open the redirect URL: " + redirectUrl);
    await openUrl(redirectUrl);
  };

  return (
    <div data-login-container>
      <img src={aimsLogo} alt="AIMS Logo" data-login-logo />
      <h2 data-login-title>Log in with Amazon Federate</h2>
      <div style={{ width: "230px" }}>
        <Button variant="normal" fullWidth="true" onClick={handleLogin}>
          <span>Log in</span>
        </Button>
      </div>
    </div>
  );
};

export default Login;
